import React, { useEffect, Suspense, useCallback, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { findBySlug } from './data/records';
import { getProjectComponent } from './data/projectRegistry';

import '../../css/Detail.css';

const Detail = () => {
    const [isLoading, setIsLoading] = useState(true);
    const { slug } = useParams();
    const navigate = useNavigate();

    const record = findBySlug(slug);
    const ProjectComponent = record ? getProjectComponent(record.component) : null;

    useEffect(() => {
        if (!record || !ProjectComponent) {
            navigate('/project', { replace: true });
        }
    }, [record, ProjectComponent, navigate]);

    useEffect(() => {
        document.body.classList.remove('loading');

        const checkResourcesLoaded = async () => {
            const images = document.getElementsByTagName('img');
            await Promise.all(Array.from(images).map(img => {
                if (img.complete) return Promise.resolve();
                return new Promise(resolve => {
                    img.onload = resolve;
                    img.onerror = resolve;
                });
            }));

            const videos = document.getElementsByTagName('video');
            await Promise.all(Array.from(videos).map(video => {
                if (video.readyState >= 3) return Promise.resolve();
                return new Promise(resolve => {
                    video.oncanplay = resolve;
                    video.onerror = resolve;
                });
            }));

            setIsLoading(false);
        };

        if (document.readyState === 'complete') {
            checkResourcesLoaded();
        } else {
            window.addEventListener('load', checkResourcesLoaded);
            return () => {
                window.removeEventListener('load', checkResourcesLoaded);
            };
        }
    }, []);

    const handleClose = useCallback(() => {
        navigate(`/project/${slug}`);
    }, [navigate, slug]);

    if (!ProjectComponent) return null;

    return (
        <div>
            <div className={`project-detail ${isLoading ? 'loading' : ''}`}>
                <button
                    className="control-button-back"
                    onClick={handleClose}
                    aria-label="Back to album view"
                >
                    <i className="fas fa-arrow-left"></i>
                </button>
                <Suspense fallback={<div className="loading-indicator">Loading...</div>}>
                    <ProjectComponent record={record} />
                </Suspense>
            </div>
        </div>
    );
};

export default Detail;
